import { useTheme } from '@mui/material/styles';
import { CONSTANTS } from '../constants/constants';
import NRWeaponizedIcon from './NRWeaponizedIcon';
import NRProofOfConceptIcon from './NRProofOfConceptIcon';
import NRUnprovenIcon from './NRUnprovenIcon';

const { POC, WEAPONIZED, UNPROVEN } = CONSTANTS.EXPLOIT_MATURITIES;

export const ExploitMaturityIconComponent = ({ maturity }) => {
  const theme = useTheme();
  switch (maturity?.toLowerCase()) {
    case UNPROVEN:
      return <NRUnprovenIcon height={theme.spacing(4)} width={theme.spacing(4)} color={theme.palette.severityPalette[2].main} />;
    case POC:
      return <NRProofOfConceptIcon height={theme.spacing(4)} width={theme.spacing(4)} color={theme.palette.severityPalette[3].main} />;
    case WEAPONIZED:
      return <NRWeaponizedIcon height={theme.spacing(4)} width={theme.spacing(4)} color={theme.palette.severityPalette[5].main} />;
    default:
      return <NRUnprovenIcon height={theme.spacing(4)} width={theme.spacing(4)} color={theme.palette.severityPalette[0].main} />;
  }
};
export default ExploitMaturityIconComponent;
